import { createSlice } from '@reduxjs/toolkit';
// utils
import axiosIntanceAccessZalo from '../../helper/axiosIntanceAccessZalo';
import apiField from '../../api/field';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  fieldTicket: [],
};
//
// name : teen store quan li
const slice = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  
    statusGetFieldTicketSuccess(state, action) {
      const participants = action.payload;
      state.fieldTicket = participants;
    },
    
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------


export function getAllFieldTicket() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await apiField.viewFieldTicket({}) ;
      dispatch(slice.actions.statusGetFieldTicketSuccess(response.data.data));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}


